import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme/theme';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Nosotros from './pages/Nosotros';
import { MisionVision, Principios, Valores, PoliticasCalidad, PoliticasPrivacidad, TerminosCondiciones } from './pages/SubPages';
import {
  BienesServicios, EscuelasAgroindustriales, RedesEmpresariales,
  BancoProyectos, MercadoAsegurado, BancoInnovacion, BancoEmprendimiento,
} from './pages/Services';
import { NuestraRed, Afiliacion, Contacto } from './pages/OtherPages';
import AdminPanel from './pages/AdminPanel';
import AdminDashboard from './pages/AdminDashboard';
import LoginEcolab from './pages/LoginEcolab';
import RecuperarPassword from './pages/RecuperarPassword';
import ConfirmarEmail    from './pages/ConfirmarEmail';
import RestablecerPassword from './pages/RestablecerPassword';
import MiPerfil from './pages/MiPerfil';
import MiPortal from './pages/MiPortal';
import ValidacionCarnet from './pages/ValidacionCarnet';
import Aliarse from './pages/Aliarse';
import EfectoEstacional from './components/EfectoEstacional';

// Rutas que renderizan sin el layout publico (Navbar / Footer)
const RUTAS_SIN_LAYOUT = ['/admin', '/login', '/v/', '/recuperar-password', '/restablecer-password', '/confirmar-email'];
// Rutas del sitio público donde NO se muestra el efecto estacional (áreas privadas del usuario)
const RUTAS_SIN_EFECTO = ['/mi-portal', '/mi-perfil'];

function Layout() {
  const { pathname } = useLocation();
  const sinLayout = RUTAS_SIN_LAYOUT.some(r => pathname.startsWith(r));

  return (
    <>
      {!sinLayout && <Navbar />}
      <main>
        <Routes>
          <Route path="/"                          element={<Home />} />
          <Route path="/nosotros"                  element={<Nosotros />} />
          <Route path="/mision-vision"             element={<MisionVision />} />
          <Route path="/principios"                element={<Principios />} />
          <Route path="/valores"                   element={<Valores />} />
          <Route path="/politicas-calidad"         element={<PoliticasCalidad />} />
          <Route path="/politicas-privacidad"      element={<PoliticasPrivacidad />} />
          <Route path="/terminos-condiciones"      element={<TerminosCondiciones />} />
          <Route path="/bienes-servicios"          element={<BienesServicios />} />
          <Route path="/escuelas-agroindustriales" element={<EscuelasAgroindustriales />} />
          <Route path="/redes-empresariales"       element={<RedesEmpresariales />} />
          <Route path="/banco-proyectos"           element={<BancoProyectos />} />
          <Route path="/mercado-asegurado"         element={<MercadoAsegurado />} />
          <Route path="/banco-innovacion"          element={<BancoInnovacion />} />
          <Route path="/banco-emprendimiento"      element={<BancoEmprendimiento />} />
          <Route path="/nuestra-red"               element={<NuestraRed />} />
          <Route path="/afiliacion"                element={<Afiliacion />} />
          <Route path="/aliarse"                   element={<Aliarse />} />
          <Route path="/contacto"                  element={<Contacto />} />
          <Route path="/admin"                     element={<AdminPanel />} />
          <Route path="/admin/dashboard"             element={<AdminDashboard />} />
          <Route path="/login"                       element={<LoginEcolab />} />
          <Route path="/recuperar-password"          element={<RecuperarPassword />} />
          <Route path="/restablecer-password"        element={<RestablecerPassword />} />
          <Route path="/confirmar-email"             element={<ConfirmarEmail />} />
          <Route path="/mi-perfil"                   element={<MiPerfil />} />
          <Route path="/mi-portal"                   element={<MiPortal />} />
          <Route path="/v/:codigo"                   element={<ValidacionCarnet />} />
        </Routes>
      </main>
      {!sinLayout && <Footer />}
      {!sinLayout && !RUTAS_SIN_EFECTO.some(r => pathname.startsWith(r)) && <EfectoEstacional pathname={pathname} />}
    </>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Layout />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
